/**
 * Name: Delete songs Reducer
 * Author: @Gaurav
 * Date: 22-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'EDIT_CUSTOMER_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'EDIT_CUSTOMER_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'EDIT_CUSTOMER_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
